"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SearchFilters = require("../../../types/SearchFilters");

var amenitiesBuilder = function amenitiesBuilder(_a) {
  var amenities = _a.amenities;

  if (!amenities || amenities && amenities.length === 0) {
    return '';
  }

  var query = [];

  if (amenities.includes(_SearchFilters.AmenitiesValue.TV)) {
    query.push('facility_tv:yes');
  }

  if (amenities.includes(_SearchFilters.AmenitiesValue.DESK)) {
    query.push('facility_desk:yes');
  }

  if (amenities.includes(_SearchFilters.AmenitiesValue.DISHWASHER)) {
    query.push('facility_dishwasher:yes');
  }

  if (amenities.includes(_SearchFilters.AmenitiesValue.WASHING_MACHINE)) {
    query.push('facility_washing_machine:yes');
  }

  if (amenities.includes(_SearchFilters.AmenitiesValue.DRYER)) {
    query.push('facility_dryer:yes');
  }

  if (amenities.includes(_SearchFilters.AmenitiesValue.AIR_CONDITIONING)) {
    query.push('facility_ac:yes');
  }

  if (amenities.includes(_SearchFilters.AmenitiesValue.HEATING)) {
    query.push("(" + [_SearchFilters.HeatingOptions.CENTRAL, _SearchFilters.HeatingOptions.ELECTRICAL, _SearchFilters.HeatingOptions.GAS, _SearchFilters.HeatingOptions.WOOD_STOVE].map(function (i) {
      return "facility_heating:" + i;
    }).join(' OR ') + ")");
  }

  return query.join(' AND ');
};

var _default = amenitiesBuilder;
exports["default"] = _default;